export default "__VITE_ASSET__8FqaXq_i__"